import login from './login'
import logout from './logout'
import refresh from './refresh'
import {login as wxLogin} from './wx-login'

export default {
  login,
  logout,
  refresh,
  wxLogin
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js